import { useEffect, useMemo, useState } from 'react';
import { debounce } from 'lodash';

export const useDebounce = () => {
  const [inputQuery, setInputQuery] = useState<string>('');
  const [inputValue, setInputValue] = useState<string>('');

  const debouncedSetInputQuery = useMemo(() => debounce(setInputQuery, 300), [setInputQuery]);

  useEffect(() => {
    debouncedSetInputQuery(inputValue);
    return () => debouncedSetInputQuery.cancel();
  }, [inputValue, debouncedSetInputQuery]);

  return {
    inputValue,
    setInputValue,
    inputQuery,
  };
};
